<template>
  <div>
    <div v-if="isSubscribed">
      <button @click="cancelSubscription" aria-label="unsubscribe">
        <v-icon>{{ "mdi-star" }}</v-icon>
      </button>
    </div>
    <div top v-else>
      <button @click="subscribe" aria-label="subscribe">
        <v-icon>{{ "mdi-star-outline" }}</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SubIcon",
  props: {
    resource: null,
  },
  computed: {
    ...mapGetters("userModule", ["getCurrentUser"]),
    isSubscribed() {
      return this.resource.subscribersIds.includes(this.getCurrentUser.id);
    },
  },
  data() {
    return {
      dialogSub: false,
    };
  },
  methods: {
    ...mapActions("subscriptionModule", [
      "subscribeToResource",
      "unsubscribeFromResource",
      "getSubscribedUsersByResource",
      "getSubscribedResources",
    ]),
    async subscribe() {
      const resources = await this.getSubscribedResources();
      if (!resources.includes(this.resource)) {
        await this.subscribeToResource(this.resource);
        // Met à jour la liste des abonnés de la ressource (this.desk) en ajoutant l'ID de l'utilisateur
        // actuellement connecté à la liste des abonnés (subscribersIds) de la ressource
        this.$set(this.resource, "subscribersIds", [
          ...this.resource.subscribersIds,
          this.getCurrentUser.id,
        ]);
      }
    },
    async cancelSubscription() {
      await this.unsubscribeFromResource(this.resource);
      // Met à jour la liste des abonnés de la ressource en filtrant l'ID de l'utilisateur actuel
      // (this.getCurrentUser.id) de la liste des abonnés actuels (this.resource.subscribersIds).
      this.$set(
        this.resource,
        "subscribersIds",
        this.resource.subscribersIds.filter(
          (userId) => userId !== this.getCurrentUser.id
        )
      );
    },
  },
};
</script>
